import { Column } from 'app/design/primitives/box';
import { Button } from 'app/design/primitives/button';
import { Text } from 'app/design/primitives/text';
import { useNavigation } from 'app/hooks/navigation';
import { useUser } from 'app/network/user';
import { canUseOfferHub, navigateToQuickPublishFlow } from 'app/screens/intro/navigator-helper';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

export function LoanReciprocityMessageCard() {
  const { t } = useTranslation('one-channel');
  const navigation = useNavigation();
  const { data: user, isPending: isUserPending } = useUser();
  const [dismissed, setDismissed] = useState(false);
  const hasOfferHubAccess = canUseOfferHub(user?.featureFlags, isUserPending);

  if (dismissed || !hasOfferHubAccess) return null;

  return (
    <Column
      backgroundColor="surface.primary-neutral"
      borderRadius="radius.lg"
      gap="spacing.general.x4"
      padding="spacing.general.x4"
    >
      <Text fontSize={14} fontWeight="700">
        {t('loanReciprocityPrompt.title')}
      </Text>
      <Text fontSize={14}>{t('loanReciprocityPrompt.description')}</Text>
      <Button
        onPress={() => navigateToQuickPublishFlow(navigation, user?.featureFlags, isUserPending)}
        variant="primary"
      >
        {t('loanReciprocityPrompt.publish')}
      </Button>
      <Button onPress={() => setDismissed(true)} variant="secondary">
        {t('loanReciprocityPrompt.later')}
      </Button>
    </Column>
  );
}
